import React from "react"
import "./css/Navbar.css"
export default function Navbar() {
    return (
        <div className="nav">
        <img src="https://www.linkpicture.com/q/earth_2.png" className="nav--logo "/>
        <h1 className="nav--text "> my travel journal .</h1>
        </div>
    )
}

